/* global globalThis */
import React, { useEffect, useRef, useState } from "react";
import "./Header.css";
import { HiMiniPencilSquare } from "react-icons/hi2";
import { FaBars, FaBell, FaCheck, FaQuestionCircle, FaCog } from "react-icons/fa";
import FalconLogo from "../../assets/falcon.png";
import { useMsal } from "@azure/msal-react";
import Select from "react-select";
import axiosClient from "../../api-client/AxiosClient";
import Joyride from "react-joyride";
import PropTypes from "prop-types";
import { useOrgConfigSync, initOrgConfigFromPrevious } from "./Orgconfigservice";


const Header = ({ isOpen, setIsOpen, run, setRun }) => {
  useOrgConfigSync();
  const { Dashboard, DataSource, Upload, STTMapping, Administration } =
    JSON.parse(sessionStorage.getItem("rolesAndPermission") || "{}");

  const { instance } = useMsal();
  const menuRef = useRef(null);
  const notificationRef = useRef(null);
  const [corporationDropdown, setCorporationDropdown] = useState();
  const [corporationList, setCorporationList] = useState([]);
  const [showOrganizationPopup, setShowOrganizationPopup] = useState(false);
  const [loggedInUser, setLoggedInUser] = useState("");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [configurationDropdown, setConfigurationDropdown] = useState();
  const [configurationList, setConfigurationList] = useState([]);
  const [showConfigurationPopup, setShowConfigurationPopup] = useState(false);
  const [showSettingsPopup, setShowSettingsPopup] = useState(false);
  const [showNoConfigMessage, setShowNoConfigMessage] = useState(false);
  const [isMandatorySelection, setIsMandatorySelection] = useState(false);




  const [steps, setSteps] = useState([
    {
      target: ".header-icon-joyride-class",
      content:
        "Falcon Mapping delivers discipline, intelligence, and simplicity to data migration and reporting, turning a traditionally complex and error-prone process into a streamlined, dependable solution for enterprises.",
      disableBeacon: true,
    },
    {
      target: ".header-corporation-joyride-class",
      content:
        "Seamlessly switch between all organizations you have access to across the platform.",
      disableBeacon: true,
    },
    {
      target: ".header-profile-joyride-class",
      content:
        "Access your account, manage profile settings, and log out across the platform.",
      disableBeacon: true,
    },
  ]);

  useEffect(() => {
    let newSteps = [...steps];

    if (Dashboard?.canView) {
      newSteps.push({
        target: ".sidebar-dashboard-joyride-class",
        content:
          "Track overall mapping progress, review system warnings, and monitor completion status across objects and users.",
        disableBeacon: true,
        placement: "right",
      });
    }
    if (DataSource?.canView) {
      newSteps.push({
        target: ".sidebar-datasource-joyride-class",
        content:
          "Connect to multiple data sources and seamlessly configure, manage, and validate source and target system connections.",
        disableBeacon: true,
        placement: "right",
      });
    }
    if (Upload?.canView) {
      newSteps.push({
        target: ".sidebar-upload-joyride-class",
        content:
          "Upload partially or fully prepared mapping documents for target system objects, with guidance on supported formats and validation.",
        disableBeacon: true,
        placement: "right",
      });
    }
    if (STTMapping?.canView) {
      newSteps.push({
        target: ".sidebar-stt-joyride-class",
        content:
          "Access existing mapping documents to complete, validate, and refine source-to-target field mappings, supported by intelligent suggestions and error highlights.",
        disableBeacon: true,
        placement: "right",
      });
    }
    newSteps.push({
      target: ".sidebar-ai-joyride-class",
      content:
        "Engage with Bluegecko's AI-powered assistant to quickly locate relevant mappings, ask questions, and receive contextual recommendations.",
      disableBeacon: true,
      placement: "right",
    });
    if (Administration?.canView) {
      newSteps.push({
        target: ".sidebar-settings-joyride-class",
        content:
          "Admin Settings provides centralized control over key system configurations. It allows you to manage users and roles, configure organizational settings, and define objects and templates to maintain consistency in mapping and reporting",
        disableBeacon: true,
        placement: "right",
      });
    }

    setSteps(newSteps);
  }, []);

  // Notification states
  const [showNotificationPopup, setShowNotificationPopup] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expandedRows, setExpandedRows] = useState(new Set());

  // Safe function to get team member name (you may need to fetch user details)
  const getTeamMemberName = (assignedTo) => {
    try {
      // For now, showing ID. You might want to fetch actual user names
      return assignedTo || "Unknown Member";
    } catch (error) {
      console.error("Error getting team member name:", error);
      return "Unknown Member";
    }
  };

  // Get priority badge color and text
  const getPriorityInfo = (priority) => {
    // Handle both string and numeric priority values
    const priorityValue =
      typeof priority === "string" ? priority.toLowerCase() : priority;
    const priorityNum = Number.parseInt(String(priority), 10);

    // Check for string values first
    if (typeof priority === "string") {
      switch (priorityValue) {
        case "high":
          return {
            color: "bg-red-100 text-red-800 border-red-200",
            text: "High",
          };
        case "medium":
          return {
            color: "bg-yellow-100 text-yellow-800 border-yellow-200",
            text: "Medium",
          };
        case "low":
          return {
            color: "bg-green-100 text-green-800 border-green-200",
            text: "Low",
          };
      }
    }

    // Check for numeric values
    switch (priorityNum) {
      case 1:
        return {
          color: "bg-red-100 text-red-800 border-red-200",
          text: "High",
        };
      case 2:
        return {
          color: "bg-yellow-100 text-yellow-800 border-yellow-200",
          text: "Medium",
        };
      case 3:
        return {
          color: "bg-green-100 text-green-800 border-green-200",
          text: "Low",
        };
      default:
        return {
          color: "bg-gray-100 text-gray-800 border-gray-200",
          text: "Medium",
        };
    }
  };

  const toggleDropdown = () => setIsMenuOpen(!isMenuOpen);

  // Fetch notifications
  const fetchNotifications = async () => {
    setLoading(true);
    try {
      const response = await axiosClient.get("/api/Task/assigned-to");
      if (response?.data) {
        setNotifications(Array.isArray(response.data) ? response.data : []);
      } else {
        setNotifications([]);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
      setNotifications([]);
    } finally {
      setLoading(false);
    }
  };

  // Toggle notification popup
  const toggleNotificationPopup = () => {
    setShowNotificationPopup(!showNotificationPopup);
    if (!showNotificationPopup) {
      fetchNotifications();
    }
  };

  // Toggle row expansion
  const toggleRowExpansion = (id) => {
    const newExpandedRows = new Set(expandedRows);
    if (newExpandedRows.has(id)) {
      newExpandedRows.delete(id);
    } else {
      newExpandedRows.add(id);
    }
    setExpandedRows(newExpandedRows);
  };

// Helper function to get Select option background color
const getSelectOptionBackgroundColor = (state) => {
  if (state.isSelected) return "#3B82F6";
  if (state.isFocused) return "#EFF6FF";
  return "white";
};

// Helper function to create Select option style
const createSelectOptionStyle = (provided, state) => {
  return {
    ...provided,
    backgroundColor: getSelectOptionBackgroundColor(state),
    color: state.isSelected ? "white" : "#374151",
    "&:hover": {
      backgroundColor: state.isSelected ? "#3B82F6" : "#EFF6FF",
    },
  };
};

// Helper function to format configuration data
const formatConfigurationData = (data) => {
  return data.map((config) => {
    const templateText = `${config.sourceName} to ${config.targetName}`;
    return {
      label: `${config.domainName} - ${templateText}`,
      value: config.organizationConfigId,
      template: templateText,
      sourceName: config.sourceName,
      targetName: config.targetName,
    };
  });
};

// Helper function to handle empty configurations
const handleEmptyConfigurations = (setShowNoConfigMessage, setConfigurationDropdown) => {
  setShowNoConfigMessage(true);
  setConfigurationDropdown(null);
  localStorage.removeItem("organization_config_id");
  // eslint-disable-next-line no-undef
  globalThis.dispatchEvent(new Event("localStorageUpdated"));
};

// Helper function to set stored configuration
const setStoredConfiguration = (formatted, storedConfigId, setConfigurationDropdown) => {
  const configExists = formatted.find(
    (c) => c.value === Number.parseInt(String(storedConfigId), 10)
  );
  if (configExists) {
    setConfigurationDropdown(configExists);
    if (configExists.template) {
      localStorage.setItem("template", configExists.template);
    }
    return true;
  }
  return false;
};

// Helper function to set first configuration as default
const setFirstConfigurationAsDefault = (formatted, setConfigurationDropdown) => {
  if (formatted.length > 0) {
    setConfigurationDropdown(formatted[0]);
    localStorage.setItem("organization_config_id", formatted[0].value);
    if (formatted[0].template) {
      localStorage.setItem("template", formatted[0].template);
    }
    // eslint-disable-next-line no-undef
    globalThis.dispatchEvent(new Event("localStorageUpdated"));
  }
};

const fetchConfigurations = React.useCallback(async (orgId) => {
  try {
    const response = await axiosClient.get(
      `/api/Organization/GetOrganizationConfigs?orgId=${orgId}`
    );
    if (response?.data) {
      const data = Array.isArray(response.data) ? response.data : [];
      const formatted = formatConfigurationData(data);
      setConfigurationList(formatted);

      if (formatted.length === 0) {
  handleEmptyConfigurations(setShowNoConfigMessage, setConfigurationDropdown);
  return;
}
setShowNoConfigMessage(false);

      // Check if there's already a stored configuration that matches
      // Only restore if it exists in the current organization's configurations
      const storedConfigId = localStorage.getItem("organization_config_id");
      if (storedConfigId) {
        const found = setStoredConfiguration(formatted, storedConfigId, setConfigurationDropdown);
        // If stored config not found in current organization, clear it and don't auto-select
        if (!found) {
          setConfigurationDropdown(null);
          localStorage.removeItem("organization_config_id");
        }
      } else {
        // Don't auto-select - let user choose manually
        setConfigurationDropdown(null);
      }
    } else {
      setConfigurationList([]);
      setConfigurationDropdown(null);
      setShowNoConfigMessage(true);
    }
} catch (error) {
    console.error("Error fetching configurations:", error);
    setConfigurationList([]);
    setConfigurationDropdown(null);
    setShowNoConfigMessage(true);
  }
}, []);


const handlePopupConfigurationChange = (selected) => {
  setConfigurationDropdown(selected);
  localStorage.setItem("organization_config_id", selected.value);
  if (selected.template) {
    localStorage.setItem("template", selected.template);
  }
  globalThis.dispatchEvent(new Event("localStorageUpdated"));
  globalThis.dispatchEvent(
    new CustomEvent("customStorageChange", {
      detail: {
        key: "organization_config_id",
        newValue: selected.value,
      },
    })
  );

  setShowOrganizationPopup(false);
  setIsMandatorySelection(false); //  Clear mandatory flag after valid selection
};
  

  const handleOpenSettings = () => {
  setIsMenuOpen(false);
  setShowSettingsPopup(true);
};

const handleSettingsOrgChange = async (selected) => {
  setCorporationDropdown(selected);
  localStorage.setItem("selectedCorporation", JSON.stringify(selected));
  
  setConfigurationDropdown(null);
  localStorage.removeItem("organization_config_id");
  setShowNoConfigMessage(false);
  
  await fetchConfigurations(selected.value);
  
  // eslint-disable-next-line no-undef
  globalThis.dispatchEvent(new Event("localStorageUpdated"));
  // eslint-disable-next-line no-undef
  globalThis.dispatchEvent(
    new CustomEvent("customStorageChange", {
      detail: {
        key: "selectedCorporation",
        newValue: JSON.stringify(selected),
      },
    })
  );
};

useEffect(() => {
  const handleStorageChange = (e) => {
    if (e.key === "organization_config_id") {
      // handled by customStorageChange
    }
  };

  const handleCustomStorageChange = (e) => {
    if (e.detail?.key === "organization_config_id" || e.detail?.key === "selectedCorporation") {
      // handled by OrgConfigSync
    }
  };

  const handleDataSourceAdded = async () => {
    const currentOrg = localStorage.getItem("selectedCorporation");
    if (currentOrg) {
      try {
        const parsed = JSON.parse(currentOrg);
        if (parsed?.value) {
          await fetchConfigurations(parsed.value);
        }
      } catch (err) {
        console.error("Error refreshing configurations after data source added:", err);
      }
    }
  };

  globalThis.addEventListener("storage", handleStorageChange);
  globalThis.addEventListener("customStorageChange", handleCustomStorageChange);
  globalThis.addEventListener("dataSourceAdded", handleDataSourceAdded);

  return () => {
    globalThis.removeEventListener("storage", handleStorageChange);
    globalThis.removeEventListener("customStorageChange", handleCustomStorageChange);
    globalThis.removeEventListener("dataSourceAdded", handleDataSourceAdded);
  };
}, [fetchConfigurations]);

const handleSettingsConfigChange = (selected) => {
  setConfigurationDropdown(selected);
  localStorage.setItem("organization_config_id", selected.value);
  if (selected.template) {
    localStorage.setItem("template", selected.template);
  }
  // eslint-disable-next-line no-undef
  globalThis.dispatchEvent(new Event("localStorageUpdated"));

  // eslint-disable-next-line no-undef
  globalThis.dispatchEvent(
    new CustomEvent("customStorageChange", {
      detail: {
        key: "organization_config_id",
        newValue: selected.value,
      },
    })
  );
  
  setShowSettingsPopup(false);
};

  
  const handleClosePopup = () => {
  setShowOrganizationPopup(false);
};


  // Handle task completion
  const handleTaskComplete = async (taskId) => {
    try {
      await axiosClient.put(`/api/Task/${taskId}/mark-read`);
      // Remove from notifications list
      setNotifications((prev) => prev.filter((notif) => notif.id !== taskId));
    } catch (error) {
      console.error("Error completing task:", error);
    }
  };

  const handleLogout = () => {
    instance.logout().catch((e) => {
      console.error(e);
    });
  };


  const handleEditOrganization = () => {
    setShowOrganizationPopup(true);
  };
const handlePopupCorporationChange = async (selected) => {
  setCorporationDropdown(selected);
  localStorage.setItem("selectedCorporation", JSON.stringify(selected));
  
  // Clear previous configuration
  setConfigurationDropdown(null);
  localStorage.removeItem("organization_config_id");
  setShowNoConfigMessage(false); // Reset message
  
  // Fetch configurations for the selected organization
  await fetchConfigurations(selected.value);
  
  // Keep popup open - both dropdowns are always visible now
  
  // eslint-disable-next-line no-undef
  globalThis.dispatchEvent(new Event("localStorageUpdated"));
  // eslint-disable-next-line no-undef
  globalThis.dispatchEvent(
    new CustomEvent("customStorageChange", {
      detail: {
        key: "selectedCorporation",
        newValue: JSON.stringify(selected),
      },
    })
  );
};

const handleOutsideClick = (e) => {
  if (isMandatorySelection) return; //  Block closing if selection is mandatory
  if (e.target === e.currentTarget || e.target.classList.contains("popup-overlay")) {
    handleClosePopup();
    setShowConfigurationPopup(false);
    setShowSettingsPopup(false);
  }
};


  // Handle clicks outside dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setShowNotificationPopup(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setLoggedInUser(
      JSON.parse(
        sessionStorage.getItem(
          JSON.parse(sessionStorage.getItem("msal.account.keys"))[0]
        )
      ).name.split(" ")
    );
  }, []);

  useEffect(() => {
    const fetchCorporations = async () => {
      //  Try to restore previous selection from API
      const previous = await initOrgConfigFromPrevious();

      const response = await axiosClient.get("/api/Organization/GetUserOrganizations");
      if (response?.data) {
        const data = Array.isArray(response.data) ? response.data : [];
        const formatted = data.map((corp) => ({
          label: corp.name,
          value: corp.organizationId,
        }));
        setCorporationList(formatted);

        if (previous?.selectedOrg) {
          //  Restore previous org from API response
          setCorporationDropdown(previous.selectedOrg);
          localStorage.setItem("selectedCorporation", JSON.stringify(previous.selectedOrg));

          await fetchConfigurations(previous.selectedOrg.value);

          if (previous?.selectedConfig) {
            //  Restore previous config from API response
            setConfigurationDropdown(previous.selectedConfig);
            localStorage.setItem("organization_config_id", previous.selectedConfig.value);
            if (previous.selectedConfig.template) {
              localStorage.setItem("template", previous.selectedConfig.template);
            }
          }

          globalThis.dispatchEvent(new Event("localStorageUpdated"));
        } else {
          // No valid previous selection — open mandatory popup
          setShowOrganizationPopup(true);
          setIsMandatorySelection(true);

          // Fallback: pre-fill org dropdown if stored locally
          const storedCorporation = localStorage.getItem("selectedCorporation");
          if (storedCorporation) {
            const parsedCorp = JSON.parse(storedCorporation);
            setCorporationDropdown(parsedCorp);
            await fetchConfigurations(parsedCorp.value);
          } else if (formatted.length > 0) {
            setCorporationDropdown(formatted[0]);
            localStorage.setItem("selectedCorporation", JSON.stringify(formatted[0]));
            await fetchConfigurations(formatted[0].value);
          }
        }
      } else {
        setCorporationList([]);
      }
    };
    fetchCorporations();
}, []);

  const handleJoyrideCallback = (data) => {
    const { status } = data;
    if (status === "finished" || status === "skipped") {
      setRun(true);
    }
  };

  return (
    <>
      <Joyride
        steps={steps}
        run={!run}
        continuous
        showProgress
        showSkipButton
        disableOverlayClose
        disableScrolling
        styles={{
          options: {
            zIndex: 10000,
          },
          overlay: {
            zIndex: 9999,
          },
          tooltipContainer: {
            zIndex: 10001,
          },
          buttonNext: {
            backgroundImage: "linear-gradient(to right, #3b82f6, #2563eb)",
            color: "#fff",
          },
          buttonBack: {
            color: "#2563eb",
            marginRight: 10,
          },
        }}
        callback={handleJoyrideCallback}
      />
      <header className="header">
        <div className="left-section">
          <button className="sidebar-toggle" onClick={() => setIsOpen(!isOpen)}>
            <FaBars />
          </button>

          <div className="flex items-center header-icon-joyride-class">
            <img src={FalconLogo} alt="NextGenlytics Logo" className="logo" />
          </div>
        </div>
        <div style={{ marginLeft: "40px", fontSize: "14px", color: "#6b7280" }}>
          <span> BlueGecko / Falcon Mapping</span>
        </div>

        <div
          className="relative w-full max-w-md mx-auto invisible"
          style={{ fontSize: "14px", color: "#6b7280" }}
        >
          <span className="absolute inset-y-0 left-0 flex items-center pl-3">
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 1117.5 10a7.5 7.5 0 01-4.85 6.65z"
              />
            </svg>
          </span>
          <input
            type="text"
            placeholder="Search objects, modules & mapping progress"
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400 text-sm text-gray-700"
          />
        </div>
        <FaQuestionCircle
          className="text-gray-600 text-lg cursor-pointer mr-4"
          title="Help"
          onClick={() => setRun(false)}
        />
        <div className="user-info">
          {/* eslint-disable-next-line no-undef */}
          {globalThis.location.pathname !== "/admin-interface" && (
            <>
              {/* Notification Icon */}
              <div className="relative" ref={notificationRef}>
                <button
                  onClick={toggleNotificationPopup}
                  className="flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors duration-200 cursor-pointer"
                  title="Notifications"
                >
                  <FaBell className="text-gray-600 text-lg" />
                  {notifications.length > 0 && (
                    <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-medium">
                      {notifications.length > 99 ? "99+" : notifications.length}
                    </span>
                  )}
                </button>

                {/* Notification Popup - Tabular Format */}
                {/* Notification Popup - Tabular Format */}
                {showNotificationPopup && (
                  <div className="absolute right-0 mt-2 w-[600px] bg-white rounded-lg shadow-xl border z-50">
                    {/* Header */}
                    <div className="px-4 py-3 border-b bg-gray-50">
                      <h3 className="font-semibold text-gray-800 text-lg">
                        To-Do List
                      </h3>
                      <p className="text-sm text-gray-600">
                        You have {notifications.length} pending tasks
                      </p>
                    </div>

                    {/* Table Content */}
                    <div>
                      {(() => {
                        if (loading) {
                          return (
                            <div className="flex items-center justify-center py-8">
                              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                              <span className="ml-2 text-gray-600">Loading...</span>
                            </div>
                          );
                        }
                        if (notifications.length === 0) {
                          return (
                            <div className="text-center py-8 text-gray-500">
                              <FaBell className="mx-auto text-3xl mb-2 opacity-50" />
                              <p>No notifications found</p>
                            </div>
                          );
                        }
                        return (
                        <div className="overflow-x-auto">
                          {/* Table Header */}
                          <div className="bg-gray-100 border-b">
                            <div className="grid grid-cols-12 gap-2 px-4 py-3 text-sm font-medium text-gray-700">
                              <div className="col-span-3">Team Member</div>
                              <div className="col-span-6">Task</div>
                              <div className="col-span-2">Priority</div>
                              <div className="col-span-1">Action</div>
                            </div>
                          </div>
                          {/* Table Rows with conditional scrolling */}
                          <div
                            className={`divide-y divide-gray-200 ${
                              notifications.length > 2
                                ? "max-h-48 overflow-y-auto"
                                : ""
                            }`}
                          >
                            {notifications.map((notification, index) => (
                              <div key={notification.id || index}>
                                {/* Main Row */}
                                <button
                                  type="button"
                                  className="w-full bg-white hover:bg-gray-50 transition-colors duration-200 cursor-pointer text-left"
                                  onClick={() =>
                                    toggleRowExpansion(notification.id || index)
                                  }
                                  aria-label={`Toggle details for task ${notification.subject || "Untitled Task"}`}
                                >
                                  <div className="grid grid-cols-12 gap-2 px-4 py-3 items-center">
                                    {/* Team Member */}
                                    <div className="col-span-3 flex items-center space-x-2">
                                      <span className="text-sm text-gray-900 truncate">
                                        {getTeamMemberName(
                                          notification.assignedTo
                                        )}
                                      </span>
                                    </div>

                                    {/* Task */}
                                    <div className="col-span-6">
                                      <p className="text-sm font-medium text-gray-900 truncate">
                                        {notification.subject ||
                                          "Untitled Task"}
                                      </p>
                                      <p className="text-xs text-gray-500 truncate">
                                        Due:{" "}
                                        {new Date(
                                          notification.dueDate
                                        ).toLocaleDateString()}
                                      </p>
                                    </div>

                                    {/* Priority */}
                                    <div className="col-span-2 flex justify-center">
                                      <span
                                        className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium border ${
                                          getPriorityInfo(notification.priority)
                                            .color
                                        }`}
                                      >
                                        {
                                          getPriorityInfo(notification.priority)
                                            .text
                                        }
                                      </span>
                                    </div>

                                    <div className="col-span-1 flex justify-start pl-4">
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleTaskComplete(notification.id);
                                        }}
                                        className="flex items-center justify-center w-8 h-8 rounded-full bg-green-100 hover:bg-green-200 transition-colors duration-200"
                                        title="Mark as complete"
                                      >
                                        <FaCheck className="text-green-600 text-sm" />
                                      </button>
                                    </div>
                                  </div>
                                </button>

                                {/* Expanded Description Row */}
                                {expandedRows.has(notification.id || index) &&
                                  notification.description && (
                                    <div className="bg-gray-50 border-t">
                                      <div className="px-4 py-3">
                                        <div className="ml-8">
                                          <div className="max-h-32 overflow-y-auto">
                                            <p className="text-sm text-gray-700 leading-relaxed">
                                              <strong>Description:</strong>{" "}
                                              {notification.description}
                                            </p>
                                          </div>
                                          <div className="mt-2 text-xs text-gray-500">
                                            <span>
                                              Created:{" "}
                                              {new Date(
                                                notification.createdOn
                                              ).toLocaleString()}
                                            </span>
                                            {notification.updatedOn && (
                                              <span className="ml-4">
                                                Updated:{" "}
                                                {new Date(
                                                  notification.updatedOn
                                                ).toLocaleString()}
                                              </span>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                              </div>
                            ))}
                          </div>
                        </div>
                        );
                      })()}
                    </div>
                  </div>
                )}
              </div>

              {/* Separator */}
              <div className="separator-line mx-3"></div>

              {corporationDropdown && (
                <button
                  type="button"
                  className="organization-hover-container"
                  onClick={
                    corporationList?.length > 1
                      ? handleEditOrganization
                      : undefined
                  }
                  disabled={corporationList?.length <= 1}
                  style={{
                    cursor: corporationList?.length > 1 ? "pointer" : "default",
                  }}
                  aria-label="Edit organization"
                >
                  <span
                    className="organization-name header-corporation-joyride-class"
                    style={{ fontSize: "14px", color: "#6b7280" }}
                  >
                    {corporationDropdown.label}
                  </span>
                  {corporationList?.length > 1 && (
                    <span className="edit-organization-btn">
                      <HiMiniPencilSquare />
                    </span>
                  )}
                </button>
              )}

              


              <div className="separator-line"></div>
            </>
          )}
          <div className="relative" ref={menuRef}>
            {/* Avatar Button */}
            <button
              type="button"
              onClick={toggleDropdown}
              className="flex items-center justify-center w-10 h-10 rounded-full bg-yellow-500 text-white font-bold cursor-pointer header-profile-joyride-class"
              aria-label="Toggle user menu"
            >
              {loggedInUser[0]?.charAt(0)}
              {loggedInUser.length > 1 &&
                loggedInUser.at(-1)?.charAt(0)}
            </button>

            {/* Dropdown */}
            {isMenuOpen && (
              <div className="absolute right-0 mt-2 w-auto bg-white rounded-lg shadow-xl border z-50">
                {/* Header */}
                <div className="flex items-center justify-between px-4 py-3 border-b">
                  <span className="font-semibold text-gray-800">BlueGecko</span>
                  <div className="flex items-center gap-3">
                    <FaCog 
                      className="text-gray-600 hover:text-blue-600 cursor-pointer transition-colors"
                      onClick={handleOpenSettings}
                      title="Settings"
                    />
                    <button
                      onClick={handleLogout}
                      className="text-sm text-blue-600 hover:underline"
                    >
                      Sign out
                    </button>
                  </div>
                </div>

                {/* Profile Info */}
                <div className="flex items-center gap-[12px] px-4 py-4">
                  <div className="flex items-center justify-center w-12 h-12 rounded-full bg-yellow-500 text-white font-bold">
                    {loggedInUser[0]?.charAt(0)}
                    {loggedInUser.length > 1 &&
                      loggedInUser.at(-1)?.charAt(0)}
                  </div>
                  <div className="flex flex-col">
                    <span className="font-medium text-gray-900">
                      {loggedInUser[0]}{" "}
                      {loggedInUser.length > 1 &&
                        loggedInUser.at(-1)}
                    </span>
                    <span className="text-sm text-gray-600">
                      {JSON.parse(
                        sessionStorage.getItem(
                          JSON.parse(
                            sessionStorage.getItem("msal.account.keys")
                          )[0]
                        )
                      ).username || ""}
                    </span>
                  </div>
                </div>
              </div>
            )}

          </div>
        </div>
      </header>

      {/* Organization Selection Popup */}
{/* Unified Selection Popup */}
{showOrganizationPopup && (
  <button
    type="button"
    className="popup-overlay"
    onClick={handleOutsideClick}
    aria-label="Close popup"
  >
    <div 
      className="popup-content"
      onClick={(e) => e.stopPropagation()}
      style={{
        transition: 'all 0.3s ease',
        maxHeight: '500px',
      }}
    >
      <h3 className="popup-title">Select Organization</h3>
      <div className="popup-body">
        <Select
          value={corporationDropdown}
          onChange={handlePopupCorporationChange}
          options={corporationList}
          placeholder="Select Organization"
          isSearchable
          styles={{
            control: (provided, state) => ({
              ...provided,
              minHeight: "40px",
              borderColor: state.isFocused ? "#3B82F6" : "#D1D5DB",
              boxShadow: state.isFocused ? "0 0 0 1px #3B82F6" : "none",
              "&:hover": {
                borderColor: "#9CA3AF",
              },
            }),
            option: createSelectOptionStyle,
          }}
        />
      </div>
      
      {/* Configuration Section - Always visible */}
      <div 
        className="popup-body"
        style={{
          marginTop: '20px',
          paddingTop: '20px',
          borderTop: '1px solid #E5E7EB',
        }}
      >
        <h3 className="popup-title" style={{ marginBottom: '10px' }}>
          Select Configuration
        </h3>
        <Select
          value={configurationDropdown}
          onChange={handlePopupConfigurationChange}
          options={configurationList}
          placeholder={corporationDropdown ? "Select Configuration" : "Select Organization first"}
          isSearchable
          isDisabled={!corporationDropdown || configurationList.length === 0}
          styles={{
            control: (provided, state) => ({
              ...provided,
              minHeight: "40px",
              borderColor: state.isFocused ? "#3B82F6" : "#D1D5DB",
              boxShadow: state.isFocused ? "0 0 0 1px #3B82F6" : "none",
              backgroundColor: (!corporationDropdown || configurationList.length === 0) ? "#F3F4F6" : "white",
              cursor: (!corporationDropdown || configurationList.length === 0) ? "not-allowed" : "pointer",
              "&:hover": {
                borderColor: (!corporationDropdown || configurationList.length === 0) ? "#D1D5DB" : "#9CA3AF",
              },
            }),
            option: createSelectOptionStyle,
          }}
        />
        
        {showNoConfigMessage && (
          <div 
            className="mt-4 px-4 py-3 bg-amber-50 border border-amber-200 rounded-lg"
            style={{
              animation: 'fadeIn 0.3s ease',
            }}
          >
            <div className="flex items-center gap-2">
              <svg 
                className="w-5 h-5 text-amber-600 flex-shrink-0" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" 
                />
              </svg>
              <div>
                <p className="text-sm text-amber-800 font-semibold">
                  No Configuration Available
                </p>
                <p className="text-xs text-amber-700 mt-1">
                  This organization doesn't have any configurations. Please select a different organization.
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  </button>
      )}
      

      {showSettingsPopup && (
  <button
    type="button"
    className="popup-overlay"
    onClick={handleOutsideClick}
    aria-label="Close settings popup"
  >
    <div className="popup-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '500px' }}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="popup-title" style={{ marginBottom: 0 }}>Settings</h3>
        <button 
          onClick={() => setShowSettingsPopup(false)}
          className="text-gray-400 hover:text-gray-600 text-xl"
        >
          ×
        </button>
      </div>
      
      <div className="popup-body">
        {/* Current Organization Section */}
        <div className="mb-6">
          <div className="block text-sm font-medium text-gray-700 mb-2">
            Current Organization
          </div>
          <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg">
            <p className="text-sm font-semibold text-gray-900">
              {corporationDropdown?.label}
            </p>
          </div>
        </div>

        {/* Change Organization */}
        {corporationList?.length > 1 && (
          <div className="mb-6">
            <label htmlFor="settings-org-select" className="block text-sm font-medium text-gray-700 mb-2">
              Change Organization
            </label>
            <Select
              id="settings-org-select"
              value={corporationDropdown}
              onChange={handleSettingsOrgChange}
              options={corporationList}
              placeholder="Select Organization"
              isSearchable
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  minHeight: "40px",
                  borderColor: state.isFocused ? "#3B82F6" : "#D1D5DB",
                  boxShadow: state.isFocused ? "0 0 0 1px #3B82F6" : "none",
                  "&:hover": {
                    borderColor: "#9CA3AF",
                  },
                }),
                option: createSelectOptionStyle,
              }}
            />
          </div>
        )}

        {/* Current Configuration Section */}
        <div className="mb-6">
          <div className="block text-sm font-medium text-gray-700 mb-2">
            Current Configuration
          </div>
          <div className="p-3 bg-green-50 border border-green-200 rounded-lg">
            <p className="text-sm font-semibold text-gray-900">
              {configurationDropdown?.label || "No configuration selected"}
            </p>
          </div>
        </div>

        {/* Change Configuration */}
        {configurationList?.length > 0 && (
          <div className="mb-4">
            <label htmlFor="settings-config-select" className="block text-sm font-medium text-gray-700 mb-2">
              Change Configuration
            </label>
            <Select
              id="settings-config-select"
              value={configurationDropdown}
              onChange={handleSettingsConfigChange}
              options={configurationList}
              placeholder="Select Configuration"
              isSearchable
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  minHeight: "40px",
                  borderColor: state.isFocused ? "#3B82F6" : "#D1D5DB",
                  boxShadow: state.isFocused ? "0 0 0 1px #3B82F6" : "none",
                  "&:hover": {
                    borderColor: "#9CA3AF",
                  },
                }),
                option: createSelectOptionStyle,
              }}
            />
          </div>
        )}
      </div>
    </div>
  </button>
      )}
      

      {/* Configuration Selection Popup */}
      {showConfigurationPopup && (
        <button
          type="button"
          className="popup-overlay"
          onClick={handleOutsideClick}
          aria-label="Close configuration popup"
        >
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <h3 className="popup-title">Select Configuration</h3>
            <div className="popup-body">
              <Select
                value={configurationDropdown}
                onChange={handlePopupConfigurationChange}
                options={configurationList}
                placeholder="Select Configuration"
                isSearchable
                styles={{
                  control: (provided, state) => ({
                    ...provided,
                    minHeight: "40px",
                    borderColor: state.isFocused ? "#3B82F6" : "#D1D5DB",
                    boxShadow: state.isFocused ? "0 0 0 1px #3B82F6" : "none",
                    "&:hover": {
                      borderColor: "#9CA3AF",
                    },
                  }),
                  option: createSelectOptionStyle,
                }}
              />
            </div>
          </div>
        </button>
      )}
    </>
  );
};

Header.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  run: PropTypes.bool.isRequired,
  setRun: PropTypes.func.isRequired,
};

export default Header;
